module.exports = __webpack_public_path__ + "static/media/logo.733eb4c2.svg";